var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScaleH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 939.9 35.7",
    style: {
      enableBackground: "new 0 0 939.9 35.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000036935935406385014320000002334953560241918352_);}\r\n\t.st2{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -12428.9863,
    y1: 4354.1606,
    x2: -11615.4443,
    y2: 4354.1606,
    gradientTransform: "matrix(-1 0 0 -1 -11548.9404 4371.4951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002335483,
    style: {
      stopColor: "#32A600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2998,
    style: {
      stopColor: "#EBFF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6322,
    style: {
      stopColor: "#FFC255"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8733,
    style: {
      stopColor: "#FF0040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    style: {
      stopColor: "#D71A40"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M870,27.3H76.5c-5.5,0-10-4.5-10-10s4.5-10,10-10H870c5.5,0,10,4.5,10,10S875.6,27.3,870,27.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116220910414400186570000009845992688244281783_",
    gradientUnits: "userSpaceOnUse",
    x1: 1410.9359,
    y1: 5776.7305,
    x2: 1410.9359,
    y2: 4838.123,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -4837.3853 1429.1096)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002335483,
    style: {
      stopColor: "#32A600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2998,
    style: {
      stopColor: "#EBFF00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6322,
    style: {
      stopColor: "#FFC255"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8733,
    style: {
      stopColor: "#FF0040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9603,
    style: {
      stopColor: "#D71A40"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116220910414400186570000009845992688244281783_)"
    },
    d: "M921.8,35.7H18.2 c-9.7,0-17.5-7.8-17.5-17.5S8.6,0.7,18.2,0.7h903.6c9.7,0,17.5,7.8,17.5,17.5S931.5,35.7,921.8,35.7z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 20.1,
    cy: 17.8,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 110.1,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 200.1,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 290,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 380,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 470,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 559.9,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 649.9,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 739.9,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 829.8,
    cy: 18,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 919.8,
    cy: 18,
    r: 15.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleH);
export default __webpack_public_path__ + "static/media/scaleH.d48b87609fd821362e95ab3b99a9ffbb.svg";
export { ForwardRef as ReactComponent };